import CoreTenets from '@posts/fp-core-tenets.mdx';
import List from '@components/Writing/List';
import React from 'react';
export default {
  CoreTenets,
  List,
  React
};